import styles from "./index.module.scss";
import Image from "../global/Image";

const OutilsProject = ({ project }) => {
  return (
    <>
      <div className={styles.outilsContain}>
        {project?.softwares?.length ? (
          <>
            <span className={styles.subtitleOutils}>Logiciels</span>

            {project.softwares.map((soft, i) => {
              return (
                <div key={"soft-" + i} className={styles.outilItemContent}>
                  <div className={styles.imageOutils}>
                    <Image
                      image={soft.icon}
                      alt={soft.icon.alt("software-icon", "icon")}
                      layout="responsive"
                      width={"40px"}
                      height={"40px"}
                    />
                  </div>
                  <span>{soft.name}</span>
                </div>
              );
            })}
          </>
        ) : null}
      </div>
      <div className={styles.languageContain}>
        {project?.languages?.length ? (
          <>
            <span className={styles.subtitleOutils}>Technologies</span>
            {project.languages.map((lang, i) => {
              return (
                <div key={"lang-" + i} className={styles.outilItemContent}>
                  <div className={styles.imageOutils}>
                    <Image
                      image={lang.icon}
                      alt={lang.icon.alt("language-icon", "icon")}
                      width={"40px"}
                      height={"40px"}
                    />
                  </div>
                  <span>{lang.name}</span>
                </div>
              );
            })}
          </>
        ) : null}
      </div>
    </>
  );
};

export default OutilsProject;
